import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDataContext } from "./DataContext";
import Skeleton from "@mui/material/Skeleton";

const OurClients = () => {
  const { clients: cachedClients, fetchClients } = useDataContext();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadClients = async () => {
      // Use cached clients if available
      if (cachedClients && cachedClients.length > 0) {
        setClients(cachedClients);
        setLoading(false);
        return;
      }

      // Fetch from API (will be cached in context)
      setLoading(true);
      await fetchClients();
      // Loading will be set false when cachedClients updates
    };

    loadClients();
  }, [cachedClients, fetchClients]);

  // Update clients when cache is populated
  useEffect(() => {
    if (cachedClients && cachedClients.length > 0 && loading) {
      setClients(cachedClients);
      setLoading(false);
    }
  }, [cachedClients, loading]);

  const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} custom-prev-arrow`}
        style={{ ...style, left: "-15px", zIndex: 1 }}
        onClick={onClick}
      />
    );
  };

  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} custom-next-arrow`}
        style={{ ...style, right: "-15px", zIndex: 1 }}
        onClick={onClick}
      />
    );
  };

  const settings = {
    dots: false, // Removed dots as per user request
    infinite: true,
    speed: 800, // Slower transition for smoothness
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000,
    cssEase: "cubic-bezier(0.87, 0, 0.13, 1)", // Custom ease for premium feel
    pauseOnHover: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true, // Show arrows
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true, // Show arrows
        },
      },
    ],
  };

  return (
    <>
      <section className="logo-list-section py-lg-5 py-4 section-background">
        <Container>

          <h2 className="text-center section-title fw-semibold mb-md-4 mb-4">Our Valued Clients</h2>

          <Row className="text-center justify-content-center">
            <Col xs={12} className="px-lg-4">
              {loading ? (
                // Skeleton Loader
                <div className="d-flex justify-content-between overflow-hidden">
                  {[1, 2, 3, 4, 5].map((item) => (
                    <div key={item} className="mx-2" style={{ width: "20%" }}>
                      <Skeleton
                        variant="rectangular"
                        height={120}
                        width="100%"
                        style={{ borderRadius: "12px" }}
                        animation="wave"
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <Slider {...settings}>
                  {clients.map((client) => (
                    <div key={client.id} className="p-1">
                      <div className="client-card">
                        <a
                          href={client.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="client-logo-wrapper"
                        >
                          <img
                            src={client.image}
                            alt={client.name}
                            className="client-logo-img"
                            loading="lazy"
                          />
                        </a>
                      </div>
                    </div>
                  ))}
                </Slider>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default OurClients;
